import { IAssetContainerEvent } from './asset-container-event';
import { INovaEntity } from './base';
import { AssetTypeEnum } from './observation';

export enum AssetContainerType {
  Trailer = 'Trailer',
  Container = 'Container',
  Oversized = 'Oversized',
  Chassis = 'Chassis',
  Reefer = 'Reefer',
  Other = 'Other'
}

export enum AssetContainerState {
  Full = 'Full',
  Empty = 'Empty',
  PartiallyLoaded = 'Partially Loaded'
}

export interface IAssetContainer extends INovaEntity {
  orgId: string;
  warehouseId: string;
  type: AssetContainerType;
  code: string;
  assetVisitId?: string | null;
  companyId?: string | null;
  notes?: string | null;
}

export enum AssetContainerYardEventType {
  Arrived = 'Arrived',
  Docked = 'Docked',
  Parked = 'Parked',
  Unassigned = 'Unassigned',
  Dropped = 'Dropped',
  Hooked = 'Hooked',
  DropAppointmentLinked = 'Drop Appointment Linked',
  DropAppointmentUnlinked = 'Drop Appointment Unlinked',
  PickupAppointmentUnlinked = 'Pickup Appointment Unlinked',
  PickupAppointmentLinked = 'Pickup Appointment Linked',
  StatusUpdated = 'Status Updated'
}

export interface IAssetContainerYardEvent {
  createDateTime: Date;
  createdBy: string;
  details?: Record<string, any>;
  eventType: AssetContainerYardEventType;
}

export function getAssetContainerStatus(
  assetContainerEvents: IAssetContainerEvent[]
): string | null {
  if (Array.isArray(assetContainerEvents) && assetContainerEvents.length > 0) {
    // Get the last event based on the createDateTime
    const lastEvent = assetContainerEvents?.reduce((prev: any, current: any) => {
      return prev.createDateTime > current.createDateTime ? prev : current;
    });

    return lastEvent?.eventType || null;
  }

  return null;
}

/**
 * Returns the corresponding `AssetContainerType` for a given `AssetTypeEnum`.
 * Maps specific `assetObservation` types to their respective `assetContainer` types.
 *
 * @param {AssetTypeEnum} assetObservationType assetObservation type to map
 * @returns {AssetContainerType} corresponding assetContainer type
 */
export function getAssetObservationType(assetObservationType: AssetTypeEnum): AssetContainerType {
  switch (assetObservationType) {
    case AssetTypeEnum.Container:
      return AssetContainerType.Container;
    case AssetTypeEnum.ContainerReefer:
      return AssetContainerType.Container;
    case AssetTypeEnum.Chassis:
      return AssetContainerType.Chassis;
    default:
      return AssetContainerType.Trailer;
  }
}
